const transformToFormValues = ({
  initialFormValues,
  actionArray,
  actionValue,
  allProducts,
  allCombos,
  allOfferDetails,
}) => ({
  ...initialFormValues,
  messageActions: actionValue
    ? 'webpage'
    : actionArray
    ? actionArray[0]
    : 'open_app',
  messageSubActions: actionArray
    ? actionArray[0] == 'products'
      ? allProducts.find((product) => product.id == actionArray[1]).name
      : actionArray[0] == 'offers'
      ? allOfferDetails.find((offer) => offer.offer_id == actionArray[1]).label
      : actionArray[0] == 'combos' && allCombos
      ? allCombos.find((combo) => combo.id == actionArray[1]).name
      : null
    : actionValue
    ? actionValue
    : null,
});

export default transformToFormValues;
